export default __webpack_public_path__ + "img/8682df4ef565793c6d9aee9ba43c1a74.png";